import * as bootstrap from 'bootstrap'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollSmoother } from "gsap/ScrollSmoother.js";
import Choices from 'choices.js'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let smoother = gsapSmoothScroller
let choicesPlan
let choicesLocation

// create the smooth scroller FIRST!

function gsapSmoothScroller() {
    // if (window.innerWidth >= 1200) {
        return ScrollSmoother.create({
            smooth: 0.8,
            smoothTouch: false,
            effects: true,
            ignoreMobileResize: true,
        });
    // }
}

function preloader() {
    gsap.timeline({
        defaults: {
            duration: 1,
            ease: 'power4.in',
        }
    })
        .to('.preloader__logo-wrapper', {
            autoAlpha: 0,
        })
        .to('.preloader__inner', {
            yPercent: -100,
        })
        .to('.preloader__outer', {
            yPercent: -100,
            onComplete: () => {
                document.querySelector('body').classList.remove('no-scroll')
            }
        }, '<0.10')
}

function navbarPlanImageChange() {
    const planList = document.querySelectorAll('.navbar-plan-list-js')
    const imageEl = document.querySelector('.navbar-plan-image-thumbnail-js')
    let i = 0

    planList.forEach(pl => {

        // SET DEFAULT IMAGE WITH FIRST IMAGE OF PLAN LIST
        if (i == 0) {
            imageEl.setAttribute('src', pl.getAttribute('data-image'))
        }

        // CHANGE IMAGE WHEN MOUSE ENTER
        pl.addEventListener('mouseenter', () => {

            imageEl.setAttribute('src', pl.getAttribute('data-image'))
        })

        i++
    });

    
}

function disableSubmitForm() {
    const formBtn = document.querySelector('.wpcf7-form-control.wpcf7-submit')

    formBtn.addEventListener('click', () => {
        formBtn.classList.add('disabled')

        setTimeout(() => {
            formBtn.classList.remove('disabled')
        }, 300);
    })
}

function changeContactCol() {
    const nameCol = document.querySelector('[data-name="name-col"]')
    const companyCol = document.querySelector('[data-name="company-col"]')
    const emailCol = document.querySelector('[data-name="email-col"]')
    const whatsappCol = document.querySelector('[data-name="whatsapp-col"]')
    const locationCol = document.querySelector('[data-name="location-col"]')
    const planCol = document.querySelector('[data-name="plan-col"]')
    const totalCol = document.querySelector('[data-name="total-col"]')
    const submitCol = document.querySelector('[data-name="submit-col"]')

    nameCol.className = 'col-12'
    companyCol.className = 'col-12'
    emailCol.className = 'col-6 col-lg-12 col-xl-6'
    whatsappCol.className = 'col-6 col-lg-12 col-xl-6'
    locationCol.className = 'col-12'
    planCol.className = 'col-6 col-lg-12 col-xl-6'
    totalCol.className = 'col-6 col-lg-12 col-xl-6'
    submitCol.className = 'col-12'
}

function displayDynamicPlan() {
    const locationButton = document.querySelector('#booking-location');

    choicesLocation = new Choices(locationButton, {
        searchEnabled: false,
        itemSelectText: ' ',
        allowHTML: true,
        shouldSort: false,
    })

    locationButton.addEventListener('change', () => {
        choicesPlan.destroy()

        let locationValue = choicesLocation.getValue(true)

        let locationArray = locationValue.split(',')

        let locationName = locationArray[0];

        const receiptEmai = document.querySelector('#receipt-email')

        receiptEmai.setAttribute('value', locationArray[1])

        const planSelectEl = document.querySelector('#booking-plan')
        planSelectEl.innerHTML = '<option value>Plan</option>'

        jsonPlan.forEach(jp => {
    
            const locations = jp['location']

            locations.forEach(loc => {
                if (loc['post_title'] == locationName) {

                    const selectEl = document.createElement('option')
            
                    selectEl.setAttribute('value', jp['title'])
                
                    selectEl.innerHTML = jp['title']
                
                    planSelectEl.appendChild(selectEl)
                }
            });
            
        });

        // INIT CHOICEJS
        choicesjsForPlan()

    })

}

function choicesjsForPlan() {

    const planButton = document.querySelector('#booking-plan');

    choicesPlan = new Choices(planButton, {
        searchEnabled: false,
        itemSelectText: ' ',
        allowHTML: true,
        shouldSort: false,
    })

}

function inputFormTooltip() {
    const locationWrapper = document.querySelector('[data-name="location-select"]')
    const planButton = document.querySelector('#booking-plan');
    const locationButton = document.querySelector('#booking-location');

    const tooltipInit = new bootstrap.Tooltip(locationWrapper, {
        placement: 'bottom',
        title: locationString, // from page file
        trigger: 'manual',
        customClass: 'custom-form__tooltip',
    })

    // Trigger with choicesjs on plan select
    planButton.addEventListener('showDropdown', () => {

        // Check if location is empty
        if (choicesLocation.getValue(true) == '') {
            tooltipInit.toggle()
        }

    })

    // Hide tooltip when location select clicked
    locationButton.addEventListener('showDropdown', () => {
        tooltipInit.hide()
    })

    // when tooltip shown, if window scroll, hide it
    locationWrapper.addEventListener('shown.bs.tooltip', () => {
        window.onscroll = function(e) {
            tooltipInit.hide()
        }
    })

    // when tooltip hidden, if window scroll, reset window
    locationWrapper.addEventListener('hidden.bs.tooltip', () => {
        window.onscroll = null
    })
}

window.addEventListener('load', () => {
    // gsapSmoothScroller().paused(true)
    preloader()
    navbarPlanImageChange()
})

export { smoother }

export { bootstrap }

export { gsap }

export { ScrollTrigger }

export { disableSubmitForm }

export { changeContactCol }

export { displayDynamicPlan }

export { choicesjsForPlan }

export { choicesPlan }

export { choicesLocation }

export { inputFormTooltip }